import { Box, SubmitButton } from '@/components';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import invariant from 'tiny-invariant';

import { useWorkflowStackSiderView } from '@/features/workflow/hooks/stack-sider-view';
import { WORKFLOW_FORM_ID } from './WorkflowForm';

export const WorkflowFormHeader: FC = () => {
  const { t } = useTranslation();

  const {
    formState: { isDirty, isSubmitting },
  } = useFormContext();

  const stackSiderView = useWorkflowStackSiderView();

  const siderConfig = stackSiderView.lastItem?.config;

  invariant(siderConfig?.viewType === 'workflow-form', t('unreachable-code'));

  return (
    <Box>
      <SubmitButton
        form={WORKFLOW_FORM_ID}
        disabled={!isDirty && !siderConfig.formValues?.uploadedFilesChanged}
        loading={isSubmitting}
      />
    </Box>
  );
};
